import { createSlice } from '@reduxjs/toolkit';
// utils

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  loading: false,
  settingsList: []
};

const slice = createSlice({
  name: 'settingsFunc',
  initialState,
  reducers: {
    // START LOADING
    getSettingsFuncAction: (state, action) => {
      const data = action.payload;

      state.settingsList = data;
    }
  }
});

// Reducer
export default slice.reducer;

export const { getSettingsFuncAction } = slice.actions;

// ----------------------------------------------------------------------
